import {
  SelectedSideOrdersT,
  SideOrderIdT,
} from '@features/orderForm/stepSelectSideOrders/services/redux/stepSelectSideOrders.slice';
import {
  MappedSideOrdersRedirectT,
  SideOrderAbbreviationE,
  SideOrderRedirectT,
} from 'typesRoot/redirect.type';
import { parseTypeAndIdFromKey } from '@features/coursesAsSideOrders/utils/coursesAsSideOrders.util';
import { SideOrderOrCourseTypeE } from '@features/coursesAsSideOrders/types/coursesAsSideOrders.type';

export const mapSideOrdersToRedirectToPanel = (
  sideOrders: SelectedSideOrdersT
) =>
  Object.keys(sideOrders).reduce<MappedSideOrdersRedirectT>((acc, currDate) => {
    const abbreviatedSideOrdersPerDay = Object.entries(
      sideOrders[currDate] || {}
    ).reduce<SideOrderRedirectT>((innerAcc, [sideOrderKey, sideOrder]) => {
      if ('multiplier' in sideOrder && sideOrder.multiplier > 0) {
        const [type, id] = parseTypeAndIdFromKey(sideOrderKey as SideOrderIdT);

        innerAcc[
          `${
            type === SideOrderOrCourseTypeE.COURSE_AS_SIDE_ORDER
              ? SideOrderAbbreviationE.COURSE_AS_SIDE_ORDER
              : SideOrderAbbreviationE.POSSIBLE_SIDE_ORDER
          }-${id}`
        ] = sideOrder.multiplier;
      }
      return innerAcc;
    }, {});
    acc[currDate] = abbreviatedSideOrdersPerDay;

    return acc;
  }, {});
